module.exports = __webpack_public_path__ + "static/media/speech_03.0ce002a5.svg";